export default "__VITE_ASSET__BCgKZ5bi__"